import { api } from "@/comn";
import { comnUtils } from "@/comn/utils";
import { TFormSchema, TGridSchema } from "@/comn/hooks";
import { ptlEnvs } from "@/tra/tancis/ptli/comn";

/*
 *  Organization User Approve Services
 * !== 기관 사용자 신청 서비스 ==!
 */

export const BASE = {
    path: `${ptlEnvs.base}/usr/orgusraprv`,
    api: `${process.env.REACT_APP_API_PTLI}/api/v1/ptli/intptl/usr/org-usr-aprv`,
    nodes: [],
};

export const URLS = {
    ptli0921001q: `${BASE.path}/ptli0921001q`, // Organization User Approve List !==  기관 사용자 신청 목록 ==!
    ptli0921002s: `${BASE.path}/ptli0921002s`, // Organization User Approve !==  기관 사용자 신청 ==!
};

export const APIS = {
    // Check Organization User Approve List !==  기관 사용자 신청 목록 조회 ==!
    getOrgUsrAprvList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },

    // Check Organization User information !==  기관 사용자 정보 조회 ==!
    getOrgUsrAprvInfo: (id: any) => {
        return api.get(`${BASE.api}/${id}`);
    },

    // Check Organization User Auth list !== 기관 사용자 권한 목록 조회 ==!
    getOgaUsrAuthList: (xtrnUsrUuid: any) => {
        return api.get(`${BASE.api}/${xtrnUsrUuid}/usr-auth`);
    },

    // Execute Organization User Approval !== 기관 사용자 승인 ==!
    executeUsrAprv: (data: any) => {
        console.log(data);
        return api.put(`${BASE.api}/aply`, {
            ...data,
        });
    },

    // !== 기관 사용자 반려 ==!
    executeUsrRtrn: (data: any) => {
        return api.put(`${BASE.api}/aply`, {
            ...data,
        });
    },

    // save Organization User Auth !== 기관 사용자 권한 저장 ==!
    saveOgaUsrAuthList: ({ tin, ...rest }: any) => {
        return api.post(`${BASE.api}/${tin}/usr-auth`, rest);
    },
};

export const SF_ORG_USR_SRCH: TFormSchema = {
    id: "form_orgSrch",
    schema: {
        orgCd: { type: "code", label: "L_ORG_CD", area: "orgCd", popupSize: "md" },
        usrNm: { type: "text", label: "L_USR_NM" },
        psnTin: { type: "text", label: "L_TIN" },
    },
};

export const SF_ORG_USR_INFO: TFormSchema = {
    id: "form_orgInfo",
    schema: {
        psnTin: { type: "text", label: "L_TIN", required: true },
        orgCd: { type: "code", label: "L_ORG_CD", area: "orgCd", popupSize: "md", required: true },
        frgnrYn: {
            type: "radio",
            label: "L_FRGNR_YN",
            options: [
                { label: "Citizen", value: "Y" },
                { label: "Foreigner", value: "N" },
            ],
            defaultValue: "N",
            required: true,
        },
        aplcCntyCd: { type: "code", label: "L_APLC_CNTY_CD", area: "cntyCd", popupSize: "md", required: true },
        usrNm: { type: "text", label: "L_USR_NM", required: true },
        usrMoblNo: { type: "text", label: "L_USR_MOBL_NO", required: true },
        usrEmlAddr: { type: "text", label: "L_USR_EML_ADDR", required: true },
        rsdtAddr: { type: "text", label: "L_RSDT_ADDR", required: true },
        usrPwd: { type: "text", label: "L_USR_PWD", required: true },
        preXtrnUsrAplyId: { type: "text" },
    },
};

export const SG_ORG_USR_LIST: TGridSchema = {
    id: "grid_orgList",
    options: { pagination: "out", index: true },
    head: [
        { cells: [{ header: "L_TIN", binding: "psnTin", width: "15%" }] },
        { cells: [{ header: "L_USR_NM", binding: "usrNm", width: "*" }] },
        { cells: [{ header: "L_ORG_NM", binding: "orgNm", width: "*" }] },
        { cells: [{ header: "L_FRST_RGSR_DTM", binding: "frstRgsrDtm", width: "15%" }] },
    ],
    body: [
        {
            cells: [{ binding: "psnTin" }],
        },
        {
            cells: [{ binding: "usrNm", align: "left" }],
        },
        {
            cells: [{ binding: "orgNm", align: "left" }],
        },
        {
            cells: [{ binding: "frstRgsrDtm", type: "datetime" }],
        },
    ],
};

export const SG_USR_AUTH_LIST: TGridSchema = {
    id: "grid_usrAuthList",
    options: { checkbox: true, height: 250 },
    head: [
        { cells: [{ header: "L_AUTH_ID", binding: "authId", width: "0.5*" }] },
        { cells: [{ header: "L_AUTH_NM", binding: "authNm", width: "0.5*" }] },
        { cells: [{ header: "L_AUTH_DESC", binding: "authDesc", width: "0.8*" }] },
        { cells: [{ header: "L_FRST_REGST_ID", binding: "frstRegstId", width: "0.5*" }] },
    ],
    body: [
        { cells: [{ binding: "authId", align: "center" }] },
        { cells: [{ binding: "authNm", align: "left" }] },
        { cells: [{ binding: "authDesc", align: "left" }] },
        { cells: [{ binding: "frstRegstId", align: "center" }] },
    ],
};
